import { render } from "./MessageThreadUsers.vue?vue&type=template&id=63f39702&scoped=true"
import script from "./MessageThreadUsers.vue?vue&type=script&lang=js"
export * from "./MessageThreadUsers.vue?vue&type=script&lang=js"

import "./MessageThreadUsers.vue?vue&type=style&index=0&id=63f39702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f39702"]])

export default __exports__